var _rect, _rect2, _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNoBroadcast = function SvgNoBroadcast(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 121,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 112,
    height: 112,
    x: 4,
    y: 4.5,
    stroke: "url(#no_broadcast_svg__a)",
    rx: 56
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 86.741,
    height: 86.741,
    x: 16.616,
    y: 17.114,
    stroke: "url(#no_broadcast_svg__b)",
    rx: 43.371
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#no_broadcast_svg__c)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 63.812,
    height: 63.812,
    x: 28.085,
    y: 28.583,
    fill: "#fff",
    rx: 31.906
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#6E3037",
    d: "M72.834 55v-5H69.5v5h-5v3.333h5v5h3.334v-5h5V55zM54.5 60a6.665 6.665 0 0 0 6.667-6.667 6.665 6.665 0 0 0-6.667-6.666 6.665 6.665 0 0 0-6.666 6.666A6.665 6.665 0 0 0 54.5 60m0-10c1.834 0 3.334 1.5 3.334 3.333s-1.5 3.334-3.334 3.334a3.343 3.343 0 0 1-3.333-3.334c0-1.833 1.5-3.333 3.333-3.333m10.65 14.267c-2.8-1.434-6.433-2.6-10.65-2.6-4.216 0-7.85 1.166-10.65 2.6-1.666.85-2.683 2.566-2.683 4.433v4.633h26.667V68.7c0-1.867-1.017-3.583-2.684-4.433M64.5 70h-20v-1.3c0-.633.334-1.2.867-1.467C47.35 66.217 50.55 65 54.5 65s7.15 1.217 9.134 2.233c.533.267.866.834.866 1.467z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "no_broadcast_svg__a",
    x1: 60,
    x2: 60,
    y1: 4,
    y2: 117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC8018"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "no_broadcast_svg__b",
    x1: 59.987,
    x2: 59.987,
    y1: 16.614,
    y2: 104.355,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC8018"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "no_broadcast_svg__c",
    width: 119.812,
    height: 119.812,
    x: 0.085,
    y: 0.583,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    "in": "SourceAlpha",
    operator: "dilate",
    radius: 4,
    result: "effect1_dropShadow_802_42469"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 0.94902 0 0 0 0 0.913725 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_802_42469"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_802_42469",
    result: "shape"
  })))));
};
export default SvgNoBroadcast;